import React, { useState, useEffect } from "react";
import { message } from "antd";
import {
  UserGet,
  UserUpdate,
  UserTransactionsPost,
  UserTotalRevenuePost,
  RechargePlanGet,
  PostChargesGet,
} from "../../Api/CoreApi";
import ProfileHeader from "./Profile_Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import "./UserRecharge.css";

const UserRecharge = () => {
  const navigate = useNavigate();
  const id = localStorage.getItem("user_id");
  const [user, setUser] = useState(null);
  const [referuser, setReferUser] = useState(null);
  const [plans, setPlans] = useState([]);
  const [urcom, setUrcom] = useState(0);

  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const user_role = localStorage.getItem("role");

  // Permission check
  useEffect(() => {
    if (!user_role || user_role !== "user") navigate("/");
  }, [user_role, navigate]);

  // Fetch user and plans
  const fetchUser = async () => {
    try {
      const allUsers = await UserGet();
      const currentUser = allUsers.find((u) => String(u.id) === String(id));
      if (!currentUser) return;

      setUser(currentUser);

      const refUser = allUsers.find((u) => u.refer === currentUser.ref);
      if (refUser) setReferUser(refUser);

      const responseplan = await RechargePlanGet();
      setPlans(responseplan);

      const rePostChargesGet = await PostChargesGet();
      setUrcom(rePostChargesGet[0]?.user_re_com || 0);
    } catch (err) {
      console.error("Error fetching user:", err);
    }
  };

  useEffect(() => {
    fetchUser();
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // Add referral commission
  const addReferCommission = async (amount) => {
    if (!referuser) return;
    const referuser_id = referuser.id;
    const updatedBalance =
      parseInt(referuser.balance || 0) + parseInt(urcom || 0);

    const response = await UserUpdate(referuser_id, { balance: updatedBalance });
    const refUser = response.find((u) => u.refer === user.ref);
    if (refUser) setReferUser(refUser);

    await UserTotalRevenuePost({
      user_amount: urcom,
      total_amount: amount,
      date: today,
      month,
      user_id: referuser_id,
    });
  };

  // Verify payment
  const handleVerify = async (paymentData, amount) => {
    try {
      const res = await fetch("https://communityrishtey.com/verify-payment/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(paymentData),
      });
      if (!res.ok) throw new Error("Payment verification failed");

      const result = await res.json();
      if (result.status === "Payment verified") {
        const updatedBalance = parseInt(user.balance || 0) + parseInt(amount);
        const respose = await UserUpdate(id, { balance: updatedBalance });
        const currentUser = respose.find((u) => String(u.id) === String(id));
        setUser(currentUser);

        await UserTransactionsPost({
          user_id: id,
          amount,
          type: "Recharge",
          status: "done",
          contact: user.contact,
        });

        addReferCommission(amount);
        message.success("Recharge successful!");
      } else {
        message.error("Payment verification failed.");
      }
    } catch (err) {
      message.error("Something went wrong during verification.");
    }
  };

  // Make payment
  const makePayment = async (amount) => {
    if (!user) return message.error("User data not loaded yet");

    try {
      const res = await fetch("https://communityrishtey.com/create-order/", {
        method: "POST",
        body: new URLSearchParams({ amount }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      const order = await res.json();
      if (!order.id) return message.error("Error creating order");

      const options = {
        key: "rzp_test_TQlquNaFwkZKZE",
        amount: order.amount,
        currency: order.currency,
        order_id: order.id,
        name: "Recharge",
        description: "Balance Top-up",
        handler: (response) => handleVerify(response, amount),
        prefill: {
          name: user.username,
          email: user.email,
          contact: user.contact,
        },
        theme: { color: "#ff0055" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      message.error("Unable to initiate payment.");
    }
  };

  return (
    <>
      <ProfileHeader />

      <div className="recharge-page">
        {/* Hero */}
        <section className="recharge-hero">
          <div className="recharge-hero-overlay"></div>

          <div className="recharge-floating-wrap">
            {["💖", "💍", "✨", "💕", "❤️", "💫", "🌸", "🎀"].map((item, index) => (
              <span key={index} className={`recharge-float recharge-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="recharge-hero-content">
            <div className="recharge-badge">💖 Premium Membership</div>

            <h1 className="recharge-title">
              Upgrade Your <span>Journey</span>
            </h1>

            <p className="recharge-subtitle">
              Unlock premium access, connect with more verified profiles,
              and enjoy a more meaningful matrimony experience.
            </p>
          </div>
        </section>

        {/* Wallet / Summary */}
        <section className="wallet-summary-section">
          <div className="wallet-summary-grid">
            <div className="wallet-box main-wallet">
              <div className="wallet-icon">💰</div>
              <div>
                <h3>Current Balance</h3>
                <p>₹ {user?.balance || 0}</p>
              </div>
            </div>

            <div className="wallet-box referral-wallet">
              <div className="wallet-icon">🎁</div>
              <div>
                <h3>Referral Benefit</h3>
                <p>₹ {urcom || 0}</p>
              </div>
            </div>

            <div className="wallet-box user-wallet">
              <div className="wallet-icon">👤</div>
              <div>
                <h3>Member</h3>
                <p>{user?.username || "Loading..."}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Membership Plans */}
        <section className="plans-section">
          <div className="plans-heading-wrap">
            <span className="plans-badge">✨ Recharge Plans</span>
            <h2 className="plans-title">Choose the Plan That Suits You Best</h2>
            <p className="plans-subtitle">
              Select a premium recharge plan and continue your search with confidence,
              visibility, and trust.
            </p>
          </div>

          <div className="plans-grid">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`luxury-plan-card ${index === 1 ? "featured-plan" : ""}`}
              >
                {index === 1 && <div className="featured-badge">Most Popular</div>}

                <div className="plan-glow"></div>

                <div className="plan-top">
                  <h3 className="plan-name">{plan.title}</h3>
                  <div className="plan-price-wrap">
                    <span className="currency-symbol">₹</span>
                    <span className="plan-price">{plan.price}</span>
                  </div>
                </div>

                <div className="plan-divider"></div>

                <div className="plan-features-list">
                  {plan.features.map((feature, i) => (
                    <div key={i} className="plan-feature-item">
                      <span className="feature-check">✔</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <button
                  className="plan-pay-btn"
                  onClick={() => makePayment(plan.price)}
                >
                  Pay Now
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default UserRecharge;